
/**
 * Обёртка одного фильтра каталога: подпись сверху, контрол снизу.
 *
 * Раньше подпись стояла в строку с контролом (`Чек-лист сервиса, ремонта или технической
 * проблемы — провален пункт: [ Все ]`). Подписи приходят из пакета и бывают длиной в
 * предложение, поэтому во flex-wrap ряду фильтры получались разной ширины и рвались по
 * строкам. Вертикальная пара фиксированной ширины укладывается в сетку при любом пакете.
 */
const NodeFilterField = ({ label, hint, children }) => (
  <div className="flex min-w-0 flex-col gap-1">
    <span className="truncate text-xs font-medium text-muted-foreground max-sm:whitespace-normal" title={hint ?? label}>
      {label}
    </span>
    {children}
  </div>
);

export default NodeFilterField;
